var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.columns && _vm.primaryKeyField)?_c('v-table',{staticClass:"v-ext-layout-fallback",attrs:{"items":_vm.items,"columns":_vm.columns,"primaryKeyField":_vm.primaryKeyField,"use-interfaces":true,"link":"__link__"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }